import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import SearchExperiments from 'bundles/epic/clients/search';

// new autocomplete
export const getShowNewAutocomplete = () => SearchExperiments.preview('showNewAutocomplete');
export const impressIntoNewAutocompleteExperiment = () => SearchExperiments.get('showNewAutocomplete');
// filter experiment utils
export const impressIntoFilterExperiment = () => SearchExperiments.get('serpFilterVariant');
export const isInFilterTestVariant = () => SearchExperiments.preview('serpFilterVariant');
export const impressIntoEQPFilterExperiment = () => SearchExperiments.get('eqpFilterVariant');
export const isInEQPFilterTestVariant = () => SearchExperiments.preview('eqpFilterVariant');
export const impressIntoBrowseFilterExperiment = () => SearchExperiments.get('browseFilterVariant');
export const isInBrowseFilterTestVariant = () => SearchExperiments.preview('browseFilterVariant');
// end filter variant utils

// Browse in SERP experiment utils
export const getShouldShowBrowseInSERP = () => GrowthDiscoveryExperiments.preview('showBrowseInSerp');
export const getShouldShowBrowseInSERPWithImpression = () => GrowthDiscoveryExperiments.get('showBrowseInSerp');

export const getSuggestionsSearchEngine = (isValidSearchSuggestionExperimentPage: boolean) => {
  if (isValidSearchSuggestionExperimentPage) {
    return SearchExperiments.get('suggestionsSearchEngine');
  }
  return null;
};

export const getConsumerProductsSearchHeavyRanker = () => SearchExperiments.get('consumerProductsSearchHeavyRanker');

export function impressCoachInSearch() {
  GrowthDiscoveryExperiments.get('coachInSearch');
}

export function showCoachInSearch(): boolean {
  return GrowthDiscoveryExperiments.preview('coachInSearch') !== 'control';
}

export const getAutoApplyFilters = () => SearchExperiments.preview('autoApplyFilters');
export const getAutoApplyFiltersWithImpression = () => SearchExperiments.get('autoApplyFilters');
export const getEQPAutoApplyFilters = () => SearchExperiments.get('eqpAutoApplyFilters');
export const getEQPAutoApplyFiltersWithImpression = () => SearchExperiments.get('eqpAutoApplyFilters');
// NL SearchSuggestions (nlSuggestionQuery experiment)
// Queries in this list will NOT use NL (Natural Language) SearchSuggestions
const NL_SEARCH_SUGGESTIONS_EXCLUSION_LIST: readonly string[] = [
  'free',
  'free courses with certificate',
  'free courses',
  'free certificate courses',
  'free course with certificate',
  'free  courses with certificate',
  'free course',
  'free/',
  'free certificate',
  'free guided projects',
  'free certificate course',
  'free degree',
  'free online courses',
  'cursos gratis',
  'gratis',
  'cursos gratis en español',
  'free certification',
  'free certificat courses',
  'free cources',
  'free courses with free certificate',
  'free courses with certificates',
  'free  courses',
  'free certification courses',
  'free certifications',
  '1 hour free',
  'free course less than 2 hours',
  'free projects',
  '/free',
  'free with certificate',
  'free online course',
  'free certification course',
  'free corse',
  'free online courses with certificate',
];

export const passesNlSuggestionQueryCheck = (query: string): boolean => {
  if (!query || !query.trim()) return false;
  const normalized = query.trim().toLowerCase();
  return !NL_SEARCH_SUGGESTIONS_EXCLUSION_LIST.includes(normalized);
};

export const isNlSuggestionQueryWithImpression = (query: string): boolean => passesNlSuggestionQueryCheck(query);

/** AI Search on LOHP experiment (still used for LOHP variant routing) */
export const impressAiSearchOnLOHP = () => GrowthDiscoveryExperiments.get('aiSearchOnLOHP');

/** Stream AI Summary experiment */
export const getStreamAISummary = () => SearchExperiments.get('streamAISummary');

/** AI Summary Product Cards flag (preview only, no impression). */
export const getAiSummaryProductCards = () => SearchExperiments.preview('aiSummaryProductCards');
